import {space} from "../compiled";
import IPriceProto = space.kenko.proto.IPriceProto;

export const priceToString = (price: IPriceProto | null | undefined) => {

  if (!price || price.amount == null || !price.currencyCode) {
    return 'ERROR';
  }

  switch (price.currencyCode.toLowerCase()) {

    case 'usd': {

      if (price.amount == 0) {
        return 'FREE';
      }

      const dollars = Math.floor((price.amount as number) / 100);
      const cents = price.amount as number % 100;
      return '$' + dollars + (cents > 0 ? ('.' + cents) : '');
    }
  }
}
